import { Link, useRouteMatch } from 'react-router-dom';
import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentPossibleAuction } from 'customHooks/useCurrentAuction';
import { dateFromServer } from 'helpers/dates';
import { inRange } from 'lodash';
import { DateTime } from 'luxon';

const AuctionEndingNotification = () => {
    const match = useRouteMatch();
    const { data: auction } = useCurrentPossibleAuction();

    const endDate = auction && dateFromServer(auction.end_at);
    const diff = endDate?.diff(DateTime.now(), 'hours').hours;
    const endsSoon = diff && inRange(diff, 0, 24);
    const isActive = auction && dateFromServer(auction.start_at) < DateTime.now();

    return isActive && endsSoon ? (
        <AlertNotification.Root type="warning">
            <AlertNotification.Icon />
            <AlertNotification.Content>
                <AlertNotification.Title>Auction ending soon!</AlertNotification.Title>
                <AlertNotification.Description className="flex flex-col gap-3">
                    <p>
                        Your auction is ending soon
                        {!auction.bid_count && ' and you still have items with no bids'}. Do you
                        want to extend your auction?
                    </p>
                    <Link
                        className="text-orange-700 hover:text-orange-800"
                        to={`${match.url}/auction`}
                    >
                        Extend auction <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                </AlertNotification.Description>
            </AlertNotification.Content>
            <AlertNotification.Close />
        </AlertNotification.Root>
    ) : null;
};

export { AuctionEndingNotification };
